import type SSEClient from "./SSEClient.js";

export abstract class SSEDataAdapter {

    public abstract on_success_msg(data: string): void
    public abstract on_error_msg(data: string): void
    public on_end_msg(client: SSEClient) {

        client.close()

    }

}